(function (window, document) {
  'use strict';
  function init(scope) {
    (scope || document).querySelectorAll('[data-gf-product]').forEach(function (root) {
      if (root.gfProductReady) return;
      root.gfProductReady = true;
      var form = root.querySelector('.gf-product__form');
      var button = form && form.querySelector('[name="add"]');
      var error = root.querySelector('[data-gf-product-error]');
      var dataNode = root.querySelector('[data-gf-product-data]');
      var data;
      try { data = JSON.parse(dataNode.textContent); } catch (_) { return; }
      var variantControl = form && form.querySelector('[name="id"]');
      var planControl = form && form.querySelector('[name="selling_plan"]');
      var quantity = form && form.querySelector('[name="quantity"]');
      var media = root.querySelectorAll('[data-gf-media]');
      var thumbnails = root.querySelectorAll('[data-gf-media-target]');
      function showMedia(id) {
        if (!Array.from(media).some(function (panel) { return panel.dataset.gfMedia === String(id); })) return;
        media.forEach(function (panel) {
          panel.hidden = panel.dataset.gfMedia !== String(id);
          if (panel.hidden) panel.querySelectorAll('video').forEach(function (video) { video.pause(); });
        });
        thumbnails.forEach(function (thumb) {
          if (thumb.dataset.gfMediaTarget === String(id)) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }
      var selectedMedia = root.querySelector('[data-gf-media-selected]') || media[0];
      if (selectedMedia) showMedia(selectedMedia.dataset.gfMedia);
      thumbnails.forEach(function (thumb) {
        thumb.addEventListener('click', function (event) { event.preventDefault(); showMedia(thumb.dataset.gfMediaTarget); });
      });
      if (!form || !variantControl || !button) return;
      if (root.dataset.gfPantryState === 'packs') {
        var initialUrl = new URL(window.location.href);
        if (initialUrl.searchParams.has('variant') && initialUrl.searchParams.get('variant') !== variantControl.value) {
          initialUrl.searchParams.set('variant', variantControl.value);
          window.history.replaceState({}, '', initialUrl);
        }
      }
      function updateVariant(changeImage) {
        var variant = data.variants.find(function (item) { return String(item.id) === variantControl.value; });
        if (!variant) return;
        var plan;
        if (planControl) {
          Array.from(planControl.options).forEach(function (option) {
            option.disabled = !!option.value && !variant.plans.some(function (entry) { return String(entry.id) === option.value; });
          });
          if (planControl.selectedOptions[0] && planControl.selectedOptions[0].disabled) {
            var available = Array.from(planControl.options).find(function (option) { return !option.disabled; });
            planControl.value = available ? available.value : '';
          }
          plan = variant.plans.find(function (entry) { return String(entry.id) === planControl.value; });
        }
        root.querySelector('[data-gf-product-price]').textContent = plan ? plan.price : variant.price;
        var compare = root.querySelector('[data-gf-product-compare]');
        compare.textContent = variant.comparePrice;
        compare.hidden = !variant.onSale || !!plan;
        var available = variant.available && (!planControl || !planControl.required || !!plan);
        button.disabled = !available;
        button.textContent = root.getAttribute(available ? 'data-add-label' : 'data-sold-out-label');
        var rule = variant.quantityRule || {};
        quantity.min = rule.min || 1;
        quantity.step = rule.increment || 1;
        if (rule.max) quantity.max = rule.max; else quantity.removeAttribute('max');
        if (+quantity.value < +quantity.min) quantity.value = quantity.min;
        if (changeImage && variant.mediaId) showMedia(variant.mediaId);
      }
      variantControl.addEventListener('change', function () {
        updateVariant(true);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantControl.value);
        window.history.replaceState({}, '', url);
      });
      if (planControl) planControl.addEventListener('change', function () { updateVariant(false); });
      updateVariant(false);
      var note = root.querySelector('[data-gf-gift-message]');
      var counter = root.querySelector('[data-gf-gift-count]');
      if (note && counter) {
        var count = function () { counter.textContent = note.value.length + ' / ' + note.maxLength; };
        note.addEventListener('input', count); count();
      }
      if (!window.fetch || !window.FormData) return;
      var adding = false;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (adding) return;
        if (!data.variants.some(function (item) { return String(item.id) === variantControl.value && item.available; })) {
          updateVariant(false);
          return;
        }
        form.querySelectorAll('#gsAppContainer input, #gsAppContainer select, #gsAppContainer textarea, .gs__product-app-container input, .gs__product-app-container select, .gs__product-app-container textarea').forEach(function (field) { field.disabled = true; });
        if (!form.reportValidity()) return;
        adding = true;
        error.hidden = true;
        button.disabled = true;
        button.textContent = 'Adding…';
        var body = new FormData(form);
        body.delete('return_to');
        if (!body.get('selling_plan')) body.delete('selling_plan');
        var routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        fetch(routesRoot + 'cart/add.js', { method:'POST', headers:{ Accept:'application/json' }, body:body })
          .then(function (response) {
            return response.json().then(function (payload) {
              if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'This item could not be added. Please try again.');
              return payload;
            });
          })
          .then(function () { window.location.assign(root.dataset.cartUrl); })
          .catch(function (problem) {
            error.textContent = problem.message || 'This item could not be added. Please try again.';
            error.hidden = false;
            adding = false;
            updateVariant(false);
          });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})(window, document);
